import React from "react";
import "../Unified.css";
import unifiedFlier from "../images/Unified/unified-L1.jpeg";

const UnifiedEvent = () => {
  return (
    <div className="unified-container">
      <h1 className="title">Welcome to UNIFIED 🙏</h1>
      <h2 className="subtitle">
        A Course from Babaji to Connect to Higher-Self
      </h2>

      <div className="event-details">
        <h3 className="event-title">
          7 Weeks of Transformational Course – Level 01
        </h3>
        <p className="guide">Hosted by Omega Pyramid</p>
        <p className="date">📅 Date: 1st October 2025</p>
        <p className="time-label">⏰ Time:</p>
        <p className="time">09:00 PM CST</p>
        <p className="time">07:30 AM IST</p>
        <p className="time">04:00 AM BST (UK)</p>
      </div>

      <div className="zoom-section">
        <a
          href="https://us02web.zoom.us/j/81935401893?pwd=6S9IUp87FUg9ue4BpBD3wXlDRwBkHM.1"
          className="zoom-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join Zoom Meeting
        </a>
        <p className="meeting-info">
          Meeting ID: <strong>879 1702 7480</strong>
        </p>
        <p className="meeting-info">
          Passcode: <strong>UNIFIED</strong>
        </p>
      </div>

      <div className="youtube-section">
        <a
          href="https://www.youtube.com/@OMEGAPYRAMID"
          className="youtube-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Watch on YouTube
        </a>
      </div>

      <div className="flier-section">
        <img src={unifiedFlier} alt="UNIFIED Course Flier" className="flier" />
      </div>

      {/* <p className="note">
        📖 Note: Please read 14 Chapters from UNIFIED book.
      </p> */}

      <p className="closing">With Love & Light,</p>
      <p className="team">UNIFIED Team</p>
    </div>
  );
};

export default UnifiedEvent;
